import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import i18n from '@/settings/i18n';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { Stars } from '../ReviewsSummary';
import ReviewsModal from '../../../../secondary/reviews/ReviewsModal';
import { formatStoreDecimal, formatStoreNumber } from '@/lib/intl-format';

const t = i18n.init('product');

const Reviews = () => {
  const {
    additionalInfo: { reviews },
  } = useProductPageContext();

  const [showReviewsModal, setShowReviewsModal] = useState(false);
  const summary = reviews?.summary;

  return (
    <>
      <button
        className="group -mt-px flex w-full items-center justify-between border-y p-4 text-left focus:outline-none"
        onClick={() => setShowReviewsModal(true)}
      >
        <div className="flex items-center gap-x-2">
          <h2 className="shrink-0 font-medium group-hover:underline">
            <span className="hidden group-hover:underline xs:inline-block">
              {t`Customer Reviews`}
            </span>
            <span className="xs:hidden">{t`Reviews`}</span>
          </h2>
          {summary && (
            <div className="flex items-center justify-center gap-1">
              <Stars stars={summary.stars} className="h-3.5" />
              <div className="flex shrink-0 items-center font-medium text-gray-700">
                <span>{formatStoreDecimal(summary.stars)}</span>
              </div>
              {summary.count > 0 && (
                <span className="hidden text-xs underline underline-offset-2 xxs:inline-block">
                  ({formatStoreNumber(summary.count)} {t`reviews`})
                </span>
              )}
            </div>
          )}
        </div>
        <ChevronRight className="h-5 w-5 shrink-0" />
      </button>

      <ReviewsModal
        showModal={showReviewsModal}
        setShowModal={setShowReviewsModal}
      />
    </>
  );
};

export default Reviews;
